export default "__VITE_ASSET__6PkDewig__"